// ==========================
// Version 4 — pages/NotFound.js (SEO noindex + branded logo 404)
// ==========================
import React from "react";
import { Link } from "react-router-dom";
import BrandLogo from "../components/BrandLogo";
import Seo from "../components/Seo";

const NAVY = "#0A1A33";
const GOLD = "#C9A44C";
const IVORY = "#FDFCF9";
const WARM_GRAY = "#888888";

export default function NotFound() {
  const pageUrl =
    typeof window !== "undefined" ? `${window.location.origin}${window.location.pathname}` : undefined;

  return (
    <>
      <Seo
        title="404 — Page not found • Blessed with a Kiss"
        description="This page doesn’t exist. Head back to the home page to continue your journey."
        url={pageUrl}
        noindex
        type="website"
      />
      <div style={wrap}>
        <div style={card} role="alert" aria-labelledby="not-found-title">
          <BrandLogo size={56} decorative style={pin} />
          <h1 id="not-found-title" style={title}>Page not found</h1>
          <p style={sub}>
            The memory you’re looking for has drifted away. Let’s take you back home.
          </p>
          <Link to="/" style={btn} aria-label="Go to home page">Go Home</Link>
        </div>
      </div>
    </>
  );
}

const wrap = {
  minHeight: "calc(100dvh - 64px)",
  background: NAVY,
  display: "grid",
  placeItems: "center",
  padding: 16,
};

const card = {
  width: "min(92vw, 520px)",
  background: IVORY,
  borderRadius: 20,
  padding: 22,
  boxShadow: "0 24px 64px rgba(10,26,51,0.40)",
  border: `1px solid rgba(201,164,76,0.35)`,
  color: NAVY,
  textAlign: "center",
};

const pin = {
  width: 56,
  height: 56,
  borderRadius: "50%",
  margin: "0 auto 10px",
  border: `2px solid ${GOLD}`,
  background: "#fff",
  padding: 5,
};

const title = {
  margin: "6px 0 4px",
  fontFamily: `"Cormorant Garamond", Georgia, serif`,
  fontSize: 28,
};

const sub = { margin: "0 0 14px", color: WARM_GRAY };

const btn = {
  display: "inline-block",
  background: GOLD,
  color: NAVY,
  padding: "10px 14px",
  borderRadius: 12,
  fontWeight: 800,
  textDecoration: "none",
};
// ==========================
// End Version 4 — pages/NotFound.js
// ==========================
